import React from 'react'

const Header = () => {
    return (
        <div className={'header'}>
            <h1>Video to GIF Converter</h1>
        </div>
    )
}

export default Header